module.exports = __webpack_public_path__ + "img/settings-unchecked.3d7c6cdb.svg";